module.exports = __webpack_public_path__ + "static/media/Close.6eaf7ee9.svg";